import { render, staticRenderFns } from "./formsTemplate.vue?vue&type=template&id=2f5d5565&scoped=true"
import script from "./formsTemplate.vue?vue&type=script&lang=js"
export * from "./formsTemplate.vue?vue&type=script&lang=js"
import style0 from "./formsTemplate.vue?vue&type=style&index=0&id=2f5d5565&scoped=true&lang=scss"
import style1 from "./formsTemplate.vue?vue&type=style&index=1&id=2f5d5565&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5d5565",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5d5565')) {
      api.createRecord('2f5d5565', component.options)
    } else {
      api.reload('2f5d5565', component.options)
    }
    module.hot.accept("./formsTemplate.vue?vue&type=template&id=2f5d5565&scoped=true", function () {
      api.rerender('2f5d5565', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_homeCloudPlatform/article/formsTemplate.vue"
export default component.exports